import ServiceCategoryPage from "../components/ServiceCategoryPage";
import popFalseCeilingWorkerService from "../data/services/popFalseCeilingWorkerService";

function POPFalseCeilingWorker() {
  return <ServiceCategoryPage service={popFalseCeilingWorkerService} />;
}

export default POPFalseCeilingWorker;